import React, { memo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { translate } from 'react-i18next';

import styled from 'styled-components';

import PerfectScrollbar from 'react-perfect-scrollbar';
import DatcanhbaoModal from 'components/modal/market/datcanhbao';
import QuanLyCanhBaoModal from 'components/modal/market/quanlycanhbao';
import BackTestModal from 'components/modal/market/backtest';
import { makeGetToken } from 'lib/selector';
import { analUserSignalRequest } from 'containers/market/actions';
import { analUserSignalSuccess } from 'containers/market/actions';
import { makeGetAnalUserSignal } from 'lib/selector';
import * as _ from 'lodash';
import { numberFormat } from 'utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ImInfo } from 'react-icons/im';
import { useContext } from 'react';
import { AlgoSignalContext } from 'containers/socket/signalAlgo';

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

//#region styled
const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 95px);
  width: 100%;
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;

  div.form-left {
    display: flex;
    align-items: center;
    margin-right: auto;
    padding-right: 15px;

    select{
      width: 320px;
    }

    label {
      white-space: nowrap;
      color: var(--half_white);
      font-size: 13px;
    }
  }

  div.form-right {
    a {
      font-size: 13px;
      color: #f0b90b;
    }

    a.signal-setup {
      background: #f0b90b;
      border-radius: 3px;
      padding: 8px 16px;
      height: 32px;
      color: #27272d;
      margin-left: 15px;
    }
  }

  select {
    width: auto;
    border: 1px solid #4e4d62;
    border-radius: 3px;
    height: 32px;
    color: var(--half_white);
    font-size: 13px;
    background-color: var(--high-light-odd);
    margin-left: 5px;
  }

  select:focus,
  select:active {
    background-color: var(--high-light-odd);
    color: var(--white);
  }
`;

const StyledBody = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px 0;
`;

const StyledDivTable = styled.div`
  position: relative;

  table {
    position: relative;
  }

  table thead th {
    position: sticky;
    top: 0;
  }

  table thead th:first-child {
    left: 0;
    z-index: 1;
    width: 86px;
  }

  table thead th:nth-child(2) {
    left: 85px;
    z-index: 1;
    width: 62px;
  }
  table thead th:nth-child(3) {
    left: 146px;
    z-index: 1;
    width: 50px;
  }

  table tbody th {
    position: sticky;
    background: #181625;
    padding: 10px 8px;
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
  }
  table tbody th:first-child {
    left: 0;
    width: 86px;
  }

  table tbody th:nth-child(2) {
    left: 85px;
    width: 62px;
  }
  table tbody th:nth-child(3) {
    left: 146px;
    width: 50px;
  }

  table.theme-light thead th {
    background: #666666;
  }
  table.theme-light.table-analysis tbody tr:nth-child(odd) td {
    background: #eeeeee;
  }
`;

const StyleBtnView = styled.button`
  padding: 6px 12px;
  background: #2C2745;
  border-radius: 3px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #ECECEC;
  border: 0;


  &:hover,
  &:focus,
  &:active {
    outline: none;
    color: #f0b90b;
    background: #878379;
  }
`;

//#endregion

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function TabAnalysisSignal(props) {
  const abortController = new AbortController();

  const [showCanhBao, setShowCanhBao] = React.useState(false);
  const [showQLy, setShowQLy] = React.useState(false);
  const [showBackTest, setShowBackTest] = React.useState(null);
  const [signalSel, setSignalSel] = React.useState(null);
  const [dataToShow, setDataToShow] = React.useState([]);
  const dispatch = useDispatch();

  const as = useContext(AlgoSignalContext);

  const { token, signals, t, receiveSignal, lang, theme, algoSignal, } = props;

  const preReceiveSignal = usePrevious(receiveSignal);
  const preSignals = usePrevious(signals);

  React.useEffect(() => {
    dispatch(analUserSignalRequest(token?.user));
    
    return () => {
      // cleanup
      dispatch(analUserSignalSuccess(null));
      abortController.abort();
    };
  }, []);

  // React.useEffect(() => {
  //   if (algoSignal) {
  //     as.sendMessage({ action: 'regSignal', account: token?.user });
  //   }
  // }, [algoSignal]);

  React.useEffect(() => {
    if (receiveSignal && !_.isEqual(receiveSignal, preReceiveSignal)) {
      processData(receiveSignal);
    }
  }, [receiveSignal]);

  React.useEffect(() => {
    if (signalSel) {
      getHistoryFormula();
    }
  }, [signalSel]);

  React.useEffect(() => {
    if (signals && !!signals.length && !_.isEqual(signals, preSignals)) {
      setSignalSel(signals[0].signalID);
      // init algo signal
      // if(!algoSignal) as.init();
    }
  }, [signals]);

  function processData(record) {
    // console.log(record);
    let _newData = [...dataToShow];
    if (_.some(_newData, (o) => o.SECURITY_CODE === record.SECURITY_CODE)) {
      _newData.map((item) => {
        if (item.SECURITY_CODE === record.SECURITY_CODE) return record;
        return item;
      });
    } else {
      _newData.push(record);
    }

    setDataToShow(_newData);
  }

  function _handleCloseModal() {
    setShowCanhBao(false);
    setShowQLy(false);
    dispatch(analUserSignalRequest(token?.user));
  }

  function _handleCloseBackTest() {
    setShowBackTest(null)
  }

  function getHistoryFormula() {
    fetch(
      appUrl +
        'pbapi/api/usersignals',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          userId: token?.user,
          signalId: Number(signalSel)
        }),
        signal: abortController.signal,
      }
    )
      .then((response) => response.json())
      .then((res) => {
        // console.// log(res);
        if (res.status === 200) {
          setDataToShow(res.data);
          // processHisFormula(res.data);
        }
      })
      .catch((error) => {
        // log(error);
      });
  }

  function processHisFormula(res) {
    console.log(res)
    let _hisFormula = [];
    res.forEach((element) => {
      _hisFormula.push({
        TRADE_DATE: element.tradeDate,
        EXCHANGE_CODE: element.exchangeCode,
        SECURITY_CODE: element.securityCode,
        SHORT_NAME: element.shortName,
        SHORT_NAME_EN: element.shortNameEN,
        LEVEL_NAME: element.levelName,
        LEVEL_NAME_EN: element.levelNameEN,
        MARKET_CAPITAL: element.marketCapital,
        PRICE_COLOR: element.priceColor,
        CLOSE_PRICE: element.closePrice,
        PRICE_CHANGE: element.priceChange,
        AVG_VOL_5D: element.avgVlol5d,
        BUY_SELL_IND: element.buySellInd,
        SEC_BT_PERF: element.secBtPerf,
        REALTIME_FORMULA_ID: element.realTimeFormulaID,
      });
    });
    setDataToShow(_hisFormula);
  }

  console.log(dataToShow);

  return (
    <StyledContainer>
      <StyledHeader>
        <div className="form-left">
          <label>{t('algo.cb.txt-Criteria')}:</label>
          <select
            className="form-control fz-13"
            onChange={(e) => setSignalSel(e.target.value)}
          >
            {signals &&
              signals.map((item, index) => {
                if (!item.active) return null;
                return (
                  <option key={index} value={item.signalID}>
                    {/* {t('algo.signal.' + item.realtimeFormulaID)} */}
                    {item.signalName}
                  </option>
                );
              })}
          </select>
          {/* {signalSel && (
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip id={`tooltip-right`}>
                  {t('algo.tooltip.' + _.find(signals, o => o.signalID == signalSel)?.realtimeFormulaID)}
                </Tooltip>
              }
            >
              <ImInfo className="ml-2 fz-12 txt-content" />
            </OverlayTrigger>
          )} */}
          {/* <label className="ml-3">Phạm vi tìm kiếm:</label>
          <select className="form-control">
            <option value="M">{'Tất cả chứng khoán'}</option>
          </select>
          <select className="form-control">
            <option value="M">{'Không hạn chế thanh khoản'}</option>
          </select> */}
        </div>
        <div className="form-right">
          <a className="signal-manager" onClick={() => setShowQLy(true)}>
            {t('algo.cb.txt-Manage-signals')}
          </a>
          <a className="signal-setup" onClick={() => setShowCanhBao(true)}>
            {t('algo.cb.txt-Set-signals')}
          </a>
        </div>
      </StyledHeader>
      <StyledBody>
        <PerfectScrollbar
          style={{ height: 'calc(100vh - 135px)' }}
          className="w-100"
        >
          <StyledDivTable>
            <table
              className={'table table-borderless table-analysis theme-' + theme}
            >
              <thead>
                <tr>
                  <th className="text-nowrap">{t('algo.cb.txt-Trade-date')}</th>
                  <th className="text-nowrap">{t('algo.cb.txt-Exchange')}</th>
                  <th className="text-nowrap">{t('algo.cb.txt-Ticker')}</th>
                  <th className="text-nowrap text-left">{t('algo.cb.txt-Name')}</th>
                  <th className="text-nowrap text-left">
                    {t('algo.ptcp.txt-Sector-ICB', { name: '4' })}
                  </th>
                  <th className="text-nowrap text-right">{t('algo.cb.txt-Market-cap')}</th>
                  <th className="text-nowrap text-right">{t('algo.cb.txt-Price')}</th>
                  <th className="text-nowrap text-right">{t('algo.cb.txt-up-down')}</th>
                  <th className="text-nowrap text-right">{t('algo.cb.txt-5-day-avg')}</th>
                  <th className="text-nowrap">{t('algo.cb.txt-Signal')}</th>
                  <th className="text-nowrap"></th>
                </tr>
              </thead>
              <tbody>
                {dataToShow &&
                  dataToShow.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center txt-content">
                        {item.TRADE_DATE.split(' ')[0]
                          .split('-')
                          .reverse()
                          .join('/')}
                      </td>
                      <td className="text-center txt-content">
                        {item.EXCHANGE_CODE}
                      </td>
                      <td className="text-center txt-content">
                        {item.SECURITY_CODE}
                      </td>
                      <td className=" txt-content">
                        {lang === 'vi' ? item.SHORT_NAME : item.SHORT_NAME_EN}
                      </td>
                      <td className=" txt-content">
                        {lang === 'vi' ? item.LEVEL_NAME : item.LEVEL_NAME_EN}
                      </td>
                      <td className="text-right txt-content">
                        {numberFormat(item.MARKET_CAPITAL, 0, '0')}
                      </td>
                      <td
                        className="text-right "
                        style={{ color: item.PRICE_COLOR }}
                      >
                        {numberFormat(item.CLOSE_PRICE, 0, '0')}
                      </td>
                      <td
                        className="text-right "
                        style={{ color: item.PRICE_COLOR }}
                      >
                        {numberFormat(item.PRICE_CHANGE, 0, '0')}
                      </td>
                      <td className="text-right  txt-content">
                        {numberFormat(item.AVG_VOL_5D, 0, '0')}
                      </td>
                      <td
                        className={
                          'text-center  txt-content ' +
                          (item.BUY_SELL_IND === 'B' ? 'i' : 'd')
                        }
                      >
                        {item.BUY_SELL_IND === 'B'
                          ? t('txt-buy')
                          : t('txt-sell')}
                      </td>
                      <td className='text-center'>
                        <StyleBtnView onClick={() => setShowBackTest(item)}>{t('algo.cb.txt-View')}</StyleBtnView>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </StyledDivTable>
          {dataToShow && !dataToShow.length && (
            <p className="text-center fz-12 content-read my-2">
              {t('txt-no-data-found')}
            </p>
          )}
        </PerfectScrollbar>
      </StyledBody>
      {showCanhBao && (
        <DatcanhbaoModal onClose={_handleCloseModal} theme={theme} />
      )}
      {showQLy && (
        <QuanLyCanhBaoModal
          onClose={_handleCloseModal}
          signals={signals}
          theme={theme}
        />
      )}
      {showBackTest && (
        <BackTestModal
          onClose={_handleCloseBackTest}
          data={showBackTest}
          theme={theme}
        />
      )}
    </StyledContainer>
  );
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAnalUserSignal = makeGetAnalUserSignal();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      signals: getAnalUserSignal(state),
      receiveSignal: state.socket.receiveSignal,
      lang: state.client?.setting?.lang || 'vi',
      theme: state.client?.setting?.theme === 'light' ? 'light' : 'dark',
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(memo(TabAnalysisSignal))
);
